import * as React from "react";
import { useLocalization } from "@shared-ui/localization-context";
import { UitkImage } from "uitk-react-images";

export const LazyLoaderPlaceHolder = (props: { name?: string }) => {
  const { formatText } = useLocalization();

  return <UitkImage alt={formatText("hotels.imagePlaceHolder", props.name)} placeholderImage={true} />;
};
